<template>
    <Multiselect
        class="ostende-select"
        :id="id"
        :value="transformedValue"
        :options="options"
        label="label"
        placeholder="tous les départements"
        multiple
        track-by="value"
        :searchable="false"
        :close-on-select="false"
        :show-pointer="showPointer"
        @input="handleChanged"
        @open="handleMultiselectOpened"
        @keydown.self.down.native="handleArrowDownPressed"
        ref="multiselect"
    >
        <template v-slot:tag="{ option }">
            <span class="ostende-select__tag text-nowrap">{{ option.label }}</span>
        </template>
        <template v-slot:option="{ option }">
            <div class="ostende-select__option">
                <b-form-checkbox :checked="isSelected(option)">
                    {{ option.label }}
                </b-form-checkbox>
            </div>
        </template>
        <template v-slot:afterList>
            <div class="text-right mt-2 px-2">
                <button class="btn btn-primary btn-sm" @click="handleOkClicked">Ok</button>
            </div>
        </template>
    </Multiselect>
</template>

<script>
    import { BFormCheckbox } from 'bootstrap-vue';
    import Multiselect from 'vue-multiselect';

    export default {
        components: {
            Multiselect,
            BFormCheckbox,
        },
        props: {
            id: String,
            value: Array,
        },
        data() {
            return {
                showPointer: false,
            }
        },
        computed: {
            options() {
                return [
                    { value:'67', label:'Bas-Rhin (67)' },
                    { value:'68', label:'Haut-Rhin (68)' },
                    { value:'08', label:'Ardennes (08)' },
                    { value:'10', label:'Aube (10)' },
                    { value:'51', label:'Marne (51)' },
                    { value:'52', label:'Haute-Marne (52)' },
                    { value:'54', label:'Meurthe-et-Moselle (54)' },
                    { value:'55', label:'Meuse (55)' },
                    { value:'57', label:'Moselle (57)' },
                    { value:'88', label:'Vosges (88)' },
                ]
            },
            transformedValue() {
                return (this.value || []).map(code =>
                    this.options.find(option => option.value === code)
                );
            },
        },
        methods: {
            handleChanged(selectedOptions) {
                const value = selectedOptions.map(option => option.value);
                this.$emit('input', value);
                this.$emit('change', value);
            },
            handleMultiselectOpened() {
                this.showPointer = false;
                this.$refs.multiselect.pointer = -1;
            },
            handleOkClicked() {
                this.$refs.multiselect.deactivate();
            },
            handleArrowDownPressed() {
                this.showPointer = true;
            },
            isSelected(option) {
                return (this.value || []).includes(option.value);
            }
        }
    }
</script>